import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";

import Icon from "@afa-shared/afa-components/dist/Icon";

import leftMenuStyles from "./LeftMenu.module.css";

export interface ILeftMenuItem {
  id: string;
  name: string;
  slug: string;
  url: string;
  level: number;
  children: Array<ILeftMenuItem>;
}

export const LeftMenu = (props) => {
  const firstLevelItems = props?.leftmenuItems;
  const router = useRouter();
  const [displayChildren, setDisplayChildren] = useState<any>({});
  const ref = useRef(null);

  useEffect(() => {
    firstLevelItems?.map((item: ILeftMenuItem) => {
      openSubMenuRecursivly(item);
    });
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router?.query?.slug]);

  const openSubMenuRecursivly = (item: ILeftMenuItem) => {
    if (itemIsActive(item) || hasActiveChildren(item)) {
      openChildren(item);
      item?.children?.map((child: ILeftMenuItem) => openSubMenuRecursivly(child));
    } else {
      setDisplayChildren((displayChildren) => {
        return {
          ...displayChildren,
          [item.id]: false,
        };
      });
    }
  };

  const itemIsActive = (item: ILeftMenuItem): boolean => item.url === router.asPath;
  const hasActiveChildren = (item: ILeftMenuItem): boolean =>
    item.children?.some((child: ILeftMenuItem) =>
      itemIsActive(child) ? true : hasActiveChildren(child)
    );

  const openChildren = (item: ILeftMenuItem) => {
    setDisplayChildren((displayChildren) => {
      return {
        ...displayChildren,
        [item.id]: true,
      };
    });
  };

  const handleClick = (item: ILeftMenuItem) => {
    setDisplayChildren({
      ...displayChildren,
      [item.id]: !displayChildren[item.id],
    });
  };

  const GetLeftMenuItem = (item: ILeftMenuItem): React.ReactNode => {
    const hasChildren = item?.children?.length > 0;
    const areaId = item.id;

    return (
      <li className={leftMenuStyles.listItem} key={item.id} data-level={item?.level}>
        <div className={leftMenuStyles.itemWrapper}>
          <Link
            href={`${item?.url}`}
            prefetch={false}
            className={`${leftMenuStyles.link} ${itemIsActive(item) ? leftMenuStyles.active : ""} ${
              hasActiveChildren(item) ? leftMenuStyles.bold : ""
            }`}
          >
            <span
              className={`${leftMenuStyles.decorator} ${
                itemIsActive(item) ? leftMenuStyles.active : ""
              }`}
              data-level={item?.level}
            ></span>
            <span
              className={`${leftMenuStyles.span} ${
                item?.level === 0 ? leftMenuStyles.levelZeroLabel : ""
              }`}
            >
              {item?.name}
            </span>
          </Link>

          {hasChildren ? (
            <button
              className={`${leftMenuStyles.iconButton} ${
                hasChildren ? leftMenuStyles.hasChildren : ""
              }`}
              onClick={() => handleClick(item)}
              aria-expanded={displayChildren[item.id] ? displayChildren[item.id] : false}
              aria-controls={areaId}
              aria-label={`Växla undermeny för ${item?.name}`}
            >
              <Icon name={displayChildren[item.id] ? "remove" : "add"} size="sm" />
            </button>
          ) : null}
        </div>

        {hasChildren && (
          <div
            className={`${leftMenuStyles.childWrapper} ${
              displayChildren[item?.id] ? leftMenuStyles.isOpen : ""
            }`}
            data-level={item?.level}
            id={areaId}
          >
            <ul className={leftMenuStyles.list} ref={ref}>
              {item?.children?.map((childItem: ILeftMenuItem) => {
                return GetLeftMenuItem(childItem);
              })}
            </ul>
          </div>
        )}
      </li>
    );
  };

  return (
    <nav aria-label={"Meny för Försäkringshandboken"}>
      <ul className={leftMenuStyles.leftMenu} data-level={1}>
        <li className={leftMenuStyles.listItem} data-level={0}>
          <div className={leftMenuStyles.itemWrapper}>
            <Link
              href={`/forsakringshandboken`}
              prefetch={false}
              className={`${leftMenuStyles.link}`}
            >
              <span className={`${leftMenuStyles.decorator}`} data-level={0}></span>
              <span className={leftMenuStyles.span}>Handbokens startsida</span>
            </Link>
          </div>
        </li>
        <li className={leftMenuStyles.listItem} data-level={0}>
          <div className={leftMenuStyles.itemWrapper}>
            <Link
              href={`/forsakringshandboken/sok-i-handboken`}
              className={`${leftMenuStyles.link} ${
                router.asPath.replace("/forsakringshandboken", "").startsWith("/sok-i-handboken")
                  ? leftMenuStyles.active
                  : ""
              }`}
              prefetch={false}
            >
              <span
                className={`${leftMenuStyles.decorator} ${
                  router.asPath.replace("/forsakringshandboken", "").startsWith("/sok-i-handboken")
                    ? leftMenuStyles.active
                    : ""
                }`}
                data-level={0}
              ></span>
              <span className={leftMenuStyles.span}>Sök i handboken</span>
            </Link>
          </div>
        </li>
        {firstLevelItems?.map((item: ILeftMenuItem) => GetLeftMenuItem(item))}
      </ul>
    </nav>
  );
};
export default LeftMenu;
